import { useState } from "react";
import UpgradeModal from "./UpgradeModal";
import "./UpgradePanel.css";

/**
 * Enticing little upsell card pinned to the bottom of the tree list
 * sidebar (see .tree-list__pinned in TreeList.css) — always visible,
 * regardless of how far the list above it is scrolled.
 *
 * Clicking Upgrade opens the paywall modal (price + what's included)
 * rather than jumping straight to checkout.
 */
export default function UpgradePanel() {
    const [open, setOpen] = useState(false);

    return (
        <div className="upgrade-panel">
            <span className="upgrade-panel__badge">Eolass Plus</span>
            <p className="upgrade-panel__title">Never hit a wall again</p>
            <p className="upgrade-panel__text">
                Unlimited courses, unlimited problems.
            </p>
            <button className="upgrade-panel__button" type="button" onClick={() => setOpen(true)}>
                Upgrade
            </button>

            <UpgradeModal open={open} onClose={() => setOpen(false)} />
        </div>
    );
}
